<template>
  <v-col
    v-if="enabled"
    :cols="cols"
    :lg="lg"
    :md="md"
  >
    <v-row dense>
      <template v-if="label">
        <v-col
          class="labeled-input"
          cols="12"
        >
          <span>{{ $bct(label) }}</span>
          <RequiredIndicator v-if="mandatory" />
          <HelpIcon
            :document="helpDocument"
            :on-help-click="openHelpFlyout"
          />
        </v-col>
      </template>
      <template v-if="description">
        <v-col
          class="fs-16 c-light-black my-1"
          cols="12"
        >
          <span>{{ $bct(description) }}</span>
        </v-col>
      </template>
      <v-col cols="12">
        <VCurrencyField
          @blur="handleBlur"
          @update:model-value="handleUpdateModelValue"
          ref="text_field"
          :append-inner-icon="locked ? 'lock' : ''"
          :aria-label="ariaLabel"
          :density="dense ? 'compact' : undefined"
          :disabled="locked"
          :distraction-free="false"
          :model-value="localValue"
          prepend-inner-icon="attach_money"
          variant="filled"
          hide-details
          tile
          v-bind="filteredAttrs"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import { onUpdated } from 'vue';

import attrsOmitDataPrefix from '@/shared/utils/filteredAttrs';
import HelpIcon from '@/shared/components/form/HelpIcon.vue';
import propsToRefs from '@/shared/utils/propsToRefs';
import RequiredIndicator from '@/shared/components/RequiredIndicator.vue';
import useLabeledField from '@/shared/composables/useLabeledField';
import useSchematizedField from '@/shared/composables/useSchematizedField';
import VCurrencyField from '@/shared/components/form/VCurrencyField.vue';

const $bct = inject('translator');

const props = defineProps({
  ...useLabeledField.props,
  ...useSchematizedField.props,
});

defineEmits(useLabeledField.emits);
const localValue = defineModel({ type: [String, Number] });

const attrs = useAttrs();
const filteredAttrs = ref(attrsOmitDataPrefix(attrs));

const { ariaLabel, enabled, helpDocument, label, locked, openHelpFlyout } = useSchematizedField(
  ...propsToRefs(props, useSchematizedField.paramKeys),
);

const { handleBlur, handleUpdateModelValue } = useLabeledField(
  ...propsToRefs(props, useLabeledField.paramKeys),
);

// attrs is not a reactive object, so we update the filteredAttrs ref on every DOM tree update
onUpdated(() => {
  filteredAttrs.value = attrsOmitDataPrefix(attrs);
});
</script>
